import Store from 'store/store';

function ensureSynopsisStateExists() {
	// TODO: ensure adding this to initialState instead (in boltUtils)
	// Currently works except for sub-pages (scrollPages)
	let store = Store.get();
	if (!store.synopsis) {
		store.set('synopsis', {});
	}
}

Store.on('TOGGLE_ONESHEET', (expandedId) => {
	ensureSynopsisStateExists();
	Store.get().synopsis.set({ onesheetExpanded: expandedId });

	Store.emit(expandedId ? 'ENABLE_SCROLLING_LOCK' : 'DISABLE_SCROLLING_LOCK');

	if (expandedId) {
		Store.emit('SET_HEADER_ACTION', {
			icon: 'close',
			action: () => Store.emit('TOGGLE_ONESHEET', null),
			tag: 'closeOnesheetOverlay',
		});
	} else {
		Store.emit('REMOVE_HEADER_ACTIONS', 'closeOnesheetOverlay');
	}
});

Store.on('CLOSE_ALL_OVERLAYS', () => {
	Store.emit('TOGGLE_ONESHEET', null);
});

Store.on('ADD_FOOTER_SHADOW', (bool) => {
	ensureSynopsisStateExists();
	Store.get().synopsis.set({ addShadowToFooter: bool });
});
